import { css } from 'aphrodite';
import * as React from 'react';
import { s } from './styles';

const Input = React.forwardRef<React.ElementRef<'input'>, AphroditeStyled<React.ComponentProps<'input'>>>(
	({ type, styles = [], ...props }, ref) => {
		return <input type={type} data-slot='input' ref={ref} className={css(s.input, ...styles)} {...props} />;
	}
);
Input.displayName = 'Input';

/** @deprecated Use InputGroupV2 instead */
const InputWrapper = React.forwardRef<React.ElementRef<'div'>, AphroditeStyled<React.ComponentProps<'div'>>>(
	({ styles = [], ...props }, ref) => {
		return <div data-slot='input-wrapper' ref={ref} className={css(s.input, s.inputWrapper, ...styles)} {...props} />;
	}
);
InputWrapper.displayName = 'InputWrapper';

export { Input, InputWrapper };
